import styled from "styled-components";

export const CommonCommentsSection = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
`;
